export default __webpack_public_path__ + "static/media/rating_9.567454d0.png";